module.exports = __webpack_public_path__ + "img/question-right.61e80fa.png";